export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";

export const GET_ROLES = "GET_ROLES";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_FAILURE = "GET_ROLES_FAILURE";

export const CREATE_ROLE = "CREATE_ROLE";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAILURE = "CREATE_ROLE_FAILURE";

export const UPDATE_ROLE = "UPDATE_ROLE";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAILURE = "UPDATE_ROLE_FAILURE";

export const UPDATE_ROLE_STATUS = "UPDATE_ROLE_STATUS";
export const UPDATE_ROLE_STATUS_SUCCESS = "UPDATE_ROLE_STATUS_SUCCESS";
export const UPDATE_ROLE_STATUS_FAILURE = "UPDATE_ROLE_STATUS_FAILURE";

export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAILURE = "DELETE_ROLE_FAILURE";

export const GET_ROLE_DATA = "GET_ROLE_DATA";
export const GET_ROLE_DATA_SUCCESS = "GET_ROLE_DATA_SUCCESS";
export const GET_ROLE_DATA_FAILURE = "GET_ROLE_DATA_FAILURE";

export const GET_ALL_PERMISSIONS = "GET_ALL_PERMISSIONS";
export const GET_ALL_PERMISSIONS_SUCCESS = "GET_ALL_PERMISSIONS_SUCCESS";
export const GET_ALL_PERMISSIONS_FAILURE = "GET_ALL_PERMISSIONS_FAILURE";

export const UPDATE_ROLE_PERMISSIONS = "UPDATE_ROLE_PERMISSIONS";
export const UPDATE_ROLE_PERMISSIONS_SUCCESS = "UPDATE_ROLE_PERMISSIONS_SUCCESS";
export const UPDATE_ROLE_PERMISSIONS_FAILURE = "UPDATE_ROLE_PERMISSIONS_FAILURE";
